<template>
  <f7-page name="confirm">
    <f7-navbar
      title="Записи"
      back-link-force
      back-link-url="/"
      back-link
    ></f7-navbar>
    <f7-block v-show="preloader">
      <f7-col class="text-align-center">
        <f7-preloader></f7-preloader>
      </f7-col>
    </f7-block>
    <f7-block v-if="isEnable" strong>
      <p>
        <f7-link href="/price/get/">История записи пуста.</f7-link>
      </p>
    </f7-block>
    <f7-block-title v-if="!isEnable">Список записей</f7-block-title>
    <f7-list media-list>
      <f7-list-item
        v-for="(order, index) in orders.data"
        :key="index"
        :link="`/order/` + order.id + `/`"
        :header="dateFormat(order.attributes.day, order.attributes.time)"
        :subtitle="getCar(order.relationships.cars.data, orders.included)"
        :title="getTitle(order.relationships.costs.data, orders.included)"
        :badge-color="colorStatus(order.attributes.status)"
        :badge="order.attributes.status"
      >
      </f7-list-item>
    </f7-list>
  </f7-page>
</template>

<script>
export default {
  data() {
    return {
      isEnable: false,
      orders: "",
      preloader: true,
    };
  },
  methods: {
    getOrders() {
      this.$f7ready((f7) => {
        let that = this;
        let days = [];
        let order = that.order;

        f7.request({
          url: "https://ms.bctip.ru/admin/api/typomojka/v1/orders",
          method: "GET",
          dataType: "json",
          data: "",
          success: function (data, status) {
            that.preloader = false;
            if (data.data.length > 0) {
              that.orders = data;
              return true;
            } else {
              that.isEnable = true;
              return false;
            }
          },
          error: function (XMLHttpRequest, textStatus, errorThrown) {
            let data = JSON.parse(XMLHttpRequest.response);
            if (data.errors != null) {
              data.errors.forEach(function (error) {
                f7.dialog.alert(
                  error.detail,
                  "Ошибка " + error.status,
                  function () {
                    if (error.status == 403) {
                      localStorage.clear();
                      f7.views.main.router.navigate("/registration/");
                    }
                  }
                );
              });
            } else {
              f7.dialog.alert(errorThrown, "Ошибка " + textStatus);
            }
          },
          beforeSend: function (xhr, settings) {
            xhr.setRequestHeader(
              "authorization",
              "Bearer " + localStorage.getItem("token")
            );
          }, //set tokenString before send
        });
      });
    },
    colorStatus(status) {
      switch (status) {
        case "В записи":
          return "green";
        default:
          return "gray";
      }
    },
    getTitle(data, included) {
      //console.log(included);
      let titles = [];
      data.forEach(function (cost) {
        included.forEach(function (costs) {
          if (cost.id == costs.id) {
            console.log(costs.attributes.title);
            titles.push(costs.attributes.title);
          }
        });
      });
      //console.log(titles);
      return titles.join(", ");
      //return "Автомойка";
    },
    dateFormat(date, time) {
      function appendLeadingZeroes(n) {
        if (n <= 9) {
          return "0" + n;
        }
        return n;
      }
      const months = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
      ];
      let current_datetime = new Date(date + "T" + time + "+05:00");
      let formatted_date =
        current_datetime.getDate() +
        " " +
        months[current_datetime.getMonth()] +
        " " +
        current_datetime.getFullYear() +
        ", " +
        appendLeadingZeroes(current_datetime.getHours()) +
        ":" +
        appendLeadingZeroes(current_datetime.getMinutes());

      return formatted_date;
    },
    getCar(data, included) {
      let list = [];
      console.log(included);
      data.forEach(function (car) {
        included.forEach(function (cars) {
          if (car.id == cars.id) {
            list.push(
              cars.attributes.carBrand + ", " + cars.attributes.stateNumber
            );
          }
        });
      });
      return list.join(", ");
    },
  },

  mounted: function () {
    this.getOrders();
  },
};
</script>

